import { useGetList } from "ra-core";

import { useRealtimeResource } from "@/hooks/useRealtimeResource";

import type { ContactApproval } from "../types";

export const usePendingContactApprovalsCount = () => {
  useRealtimeResource("contact_approvals");

  const { total = 0 } = useGetList<ContactApproval>("contact_approvals", {
    filter: { "status@eq": "pending" },
    pagination: { page: 1, perPage: 1 },
    sort: { field: "created_at", order: "DESC" },
  });

  return total;
};
